import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrgServiceService {
 
  constructor(private http: HttpClient) { }

  endpoint = {
    "org": "/orgOnboarding",
    "create": "/createOrganizationThrift",
    "list": "/listOrgThrift"
  }

  private BASE_URL = environment.baseUrl;

  newOrg(data:any){
    let result = this.http.post(this.BASE_URL+this.endpoint.org, data);
    return result;
  }

  fetchOrg(id:any){
    return this.http.get(`${this.BASE_URL}/fetch_organization?userAccountNumber=${id}`)
  }

  orgThrift(data: any){
    let result = this.http.post(this.BASE_URL+this.endpoint.create, data);
    return result
  }

  fetchOrgThrifts(id:any){
    let result = this.http.get(`${this.BASE_URL+this.endpoint.list}?orgAccountNo=${id}`);
    return result;
  }
}
